import { MiddlewareAPI, Dispatch, Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { Actions } from './actions';
import { GlobalState } from './reducers';

const handleAction = async (
    action: Actions,
    state: GlobalState,
    dispatch: ThunkDispatch<GlobalState, null, Actions>,
): Promise<void> => {
    return;
};

const createAppReduxMiddleware = () => (api: MiddlewareAPI<Dispatch, GlobalState>) => {
    return (next: Dispatch<Actions>) => (action: Action) => {
        const result = next(action);

        handleAction(action, api.getState(), api.dispatch).catch((err) => {
            console.log('appMiddleware: Error handelling action', err);
        });
        return result;
    };
};

const appReduxMiddleware = createAppReduxMiddleware();

export default appReduxMiddleware;
